module.exports = __webpack_public_path__ + "bgHeaderAbout.jpg?e5c312cfac9ff3c2f7cd3b5404a1a1c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bgHeaderAbout.jpg
// module id = 80
// module chunks = 0